import type { InterviewTier } from "../Lib/interviewApi";

type MockInterviewVisual = {
    image: string;
    alt: string;
};

export const mockInterviewVisuals: Record<InterviewTier, MockInterviewVisual> = {
    SERVICE: {
        image: "/images/jpg/mock-interview-service.webp",
        alt: "Service Company Mock Interview preparation graphic",
    },
    PRODUCT: {
        image: "/images/jpg/mock-interview-product.webp",
        alt: "Product Company Mock Interview preparation graphic",
    },
    MAANG: {
        image: "/images/jpg/mock-interview-maang.webp",
        alt: "MAANG Company Mock Interview preparation graphic",
    },
};
